import reduceReducers from 'reduce-reducers';
import roadGraphGetSegments from '@modules/road-graph/editor/reducers/get-segments';
import roadGraphSetSegment from '@modules/road-graph/editor/reducers/set-segment';

const editorReducer = reduceReducers(roadGraphGetSegments, roadGraphSetSegment);

export default editorReducer;
